// extracted by mini-css-extract-plugin
module.exports = {"priceText":"CollectionsTable_priceText__ya5cy","greenText":"CollectionsTable_greenText___90tF"};